/* Nida Safety — satış bileşenleri (TEST teması)
   - Kartta beden seçip sepete ekleme (.nbs)
   - Sepete uçan ürün animasyonu (temanın <fly-to-cart> öğesi)
   - Sepet çekmecesi "birlikte alın" (<nida-sepet-oneri>)
   - Sekmeli çok satanlar (<nida-sekmeler>)
   Tema ile konuşma: 'cart:update' olayı (temanın CartAddEvent'iyle aynı ad) →
   çekmece kendi bölümünü yeniler ve auto-open açıksa açılır. */
(() => {
  const EN = /^en/i.test(document.documentElement.lang); // /en sürümü metinleri
  const KOK = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const TL = (kurus) =>
    (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';

  const sepetBolumleri = () =>
    [...document.querySelectorAll('cart-items-component[data-section-id]')].map((e) => e.dataset.sectionId);

  function uc(kaynak, gorselUrl) {
    const hedef = document.querySelector('.header-actions__cart-icon');
    if (!kaynak || !hedef || !gorselUrl || !customElements.get('fly-to-cart')) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const f = document.createElement('fly-to-cart');
    f.classList.add('fly-to-cart--quick');
    f.style.setProperty('background-image', `url(${gorselUrl})`);
    f.style.setProperty('--start-opacity', '0');
    f.source = kaynak;
    f.destination = hedef;
    document.body.appendChild(f);
  }

  async function sepeteEkle(varyantId, tetikleyen, gorselUrl) {
    const bolumler = sepetBolumleri();
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(varyantId), quantity: 1 }],
        sections: bolumler.join(','),
        sections_url: location.pathname,
      }),
    });
    const veri = await r.json();
    if (!r.ok) throw new Error(veri.description || veri.message || (EN ? 'Could not add to cart' : 'Sepete eklenemedi'));
    const sepet = await fetch('/cart.js').then((x) => x.json());
    uc(tetikleyen, gorselUrl);
    const olay = new Event('cart:update', { bubbles: true });
    olay.detail = {
      resource: sepet,
      sourceId: 'nida-satis',
      data: { source: 'nida-satis', itemCount: sepet.item_count, variantId: String(varyantId), sections: veri.sections },
    };
    tetikleyen.dispatchEvent(olay);
    return sepet;
  }

  /* ---------- Beden düğmelerini artan sıraya diz (yalnız hepsi sayıysa: 36…48, 7/S…) ---------- */
  const sayiSira = (liste) => {
    const b = [...liste.children];
    const n = (x) => parseFloat(String(x.textContent).replace(',', '.'));
    if (b.length < 2 || b.some((x) => Number.isNaN(n(x)))) return;
    b.sort((x, y) => n(x) - n(y)).forEach((x) => liste.appendChild(x));
  };
  const hepsiniDiz = (kok) => (kok || document).querySelectorAll('.nbs__liste').forEach(sayiSira);
  window.nidaBedenDiz = hepsiniDiz; // sonradan eklenen kartlar için (ör. merdiven)
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => hepsiniDiz()) : hepsiniDiz();

  /* ---------- Kartta beden seçimi ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('.nbs__b');
    if (!b || b.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    const kutu = b.closest('.nbs');
    kutu.querySelector('.nbs__hata')?.remove();
    b.classList.add('is-yukleniyor');
    try {
      const galeri = b.closest('.card-gallery, .nsc-kart__gorsel');
      const img = galeri?.querySelector('img');
      await sepeteEkle(b.dataset.v, img || b, img?.currentSrc || img?.src || kutu.dataset.gorsel);
      b.classList.remove('is-yukleniyor');
      b.classList.add('is-eklendi');
      setTimeout(() => b.classList.remove('is-eklendi'), 1400);
    } catch (hata) {
      b.classList.remove('is-yukleniyor');
      const p = document.createElement('p');
      p.className = 'nbs__hata';
      p.textContent = hata.message;
      kutu.appendChild(p);
    }
  });
  // Beden kutusuna tıklama kartın linkine gitmesin
  document.addEventListener('pointerdown', (e) => { if (e.target.closest('.nbs')) e.stopPropagation(); }, true);

  /* ---------- Mobil: alttan açılan hızlı beden paneli ----------
     Masaüstündeki .nbs kutusu fareyle açılır; dokunmatikte "üzerine gelme" yok. Kartın "Beden seç" düğmesi
     (.nsc-kart__mobil-ekle) kartında .nbs varsa bu paneli açar. Yerel <dialog>: Esc, odak tuzağı ve odağın geri
     dönmesi tarayıcıdan. Aşağı çekince (mesafe ya da hız) kapanır. Beden düğmeleri .nbs__b → yukarıdaki ekleme mantığı. */
  let panel = null;
  const panelKur = () => {
    if (panel) return panel;
    panel = document.createElement('dialog');
    panel.className = 'nbs-sayfa';
    panel.setAttribute('aria-labelledby', 'nbs-sayfa-ad');
    panel.innerHTML = '<div class="nbs-sayfa__tut" aria-hidden="true"></div>'
      + '<div class="nbs-sayfa__ust"><img alt="" width="72" height="72"><div><p class="nbs-sayfa__ad" id="nbs-sayfa-ad"></p><p class="nbs-sayfa__fiyat"></p></div>'
      + '<button type="button" class="nbs-sayfa__kapat" aria-label="' + (EN ? 'Close' : 'Kapat') + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>'
      + '<div class="nbs nbs-sayfa__govde"><p class="nbs__baslik"><span></span></p><div class="nbs__liste"></div></div>'
      + '<a class="nbs-sayfa__detay" href="#">' + (EN ? 'Go to product page' : 'Ürün sayfasına git') + '</a>';
    document.body.appendChild(panel);
    panel.addEventListener('close', () => document.documentElement.classList.remove('nbs-kilit'));
    const kapat = () => panel.open && panel.close();
    panel.querySelector('.nbs-sayfa__kapat').addEventListener('click', kapat);
    panel.addEventListener('click', (e) => { if (e.target === panel) kapat(); }); // arka plana dokununca
    // eklendikten sonra kapan (sepet çekmecesi tema tarafından açılır)
    panel.addEventListener('cart:update', () => setTimeout(kapat, 650));
    // aşağı çekerek kapatma: 90 px ya da hızlı fiske
    let y0 = null, t0 = 0, dy = 0;
    const tut = panel.querySelector('.nbs-sayfa__tut'), ust = panel.querySelector('.nbs-sayfa__ust');
    [tut, ust].forEach((el) => el.addEventListener('pointerdown', (e) => {
      if (e.target.closest('button')) return;
      y0 = e.clientY; t0 = performance.now(); dy = 0; panel.classList.add('is-surukle'); el.setPointerCapture(e.pointerId);
    }));
    [tut, ust].forEach((el) => el.addEventListener('pointermove', (e) => {
      if (y0 === null) return;
      dy = Math.max(0, e.clientY - y0); panel.style.transform = `translateY(${dy}px)`;
    }));
    const birak = () => {
      if (y0 === null) return;
      const hiz = dy / Math.max(1, performance.now() - t0);
      y0 = null; panel.classList.remove('is-surukle'); panel.style.transform = '';
      if (dy > 90 || hiz > 0.11) kapat();
    };
    [tut, ust].forEach((el) => { el.addEventListener('pointerup', birak); el.addEventListener('pointercancel', birak); });
    return panel;
  };
  document.addEventListener('click', (e) => {
    const d = e.target.closest('.nsc-kart__mobil-ekle');
    if (!d) return;
    const kutu = d.closest('.nsc-kart')?.querySelector('.nbs');
    if (!kutu || typeof HTMLDialogElement === 'undefined') return; // bedensiz ürün / eski tarayıcı: ürün sayfasına git
    e.preventDefault();
    const p = panelKur();
    const img = p.querySelector('.nbs-sayfa__ust img');
    img.src = kutu.dataset.gorsel || '';
    p.querySelector('.nbs-sayfa__ad').textContent = kutu.dataset.baslik || '';
    p.querySelector('.nbs-sayfa__fiyat').textContent = kutu.dataset.fiyat || '';
    p.querySelector('.nbs__baslik span').textContent = EN ? 'Choose size' : (kutu.dataset.secenek || 'Beden') + ' seç';
    p.querySelector('.nbs-sayfa__detay').href = kutu.dataset.url || d.href;
    const govde = p.querySelector('.nbs-sayfa__govde');
    govde.dataset.gorsel = kutu.dataset.gorsel || '';
    govde.querySelector('.nbs__hata')?.remove();
    const liste = govde.querySelector('.nbs__liste');
    liste.replaceChildren(...[...kutu.querySelectorAll('.nbs__b')].map((b) => {
      const k = b.cloneNode(true); k.classList.remove('is-yukleniyor', 'is-eklendi'); return k;
    }));
    sayiSira(liste);
    p.showModal();
    // INP: kilit sınıfı (tüm sayfa stil hesabı) ve odak ekran boyandıktan sonra (2026-09-28)
    requestAnimationFrame(() => setTimeout(() => {
      if (!p.open) return;
      document.documentElement.classList.add('nbs-kilit');
      liste.querySelector('.nbs__b:not([disabled])')?.focus({ preventScroll: true });
    }, 0));
  });

  /* ---------- Sepet çekmecesi: birlikte alın ---------- */
  const oneriOnbellek = new Map();
  class NidaSepetOneri extends HTMLElement {
    static observedAttributes = ['data-pid', 'data-sepet'];
    connectedCallback() {
      this.gozcu = new MutationObserver(() => { if (!this.childElementCount && this.sonHtml) this.innerHTML = this.sonHtml; });
      this.gozcu.observe(this, { childList: true });
      this.ciz();
    }
    disconnectedCallback() { this.gozcu?.disconnect(); }
    attributeChangedCallback() { if (this.isConnected) this.ciz(); }
    async ciz() {
      const pid = this.dataset.pid;
      if (!pid) { this.sonHtml = ''; this.innerHTML = ''; return; }
      const sepettekiler = (this.dataset.sepet || '').split(',');
      let urunler = oneriOnbellek.get(pid);
      if (!urunler) {
        try {
          const r = await fetch(`${KOK}recommendations/products.json?product_id=${pid}&intent=complementary&limit=6`);
          urunler = (await r.json()).products || [];
        } catch { urunler = []; }
        oneriOnbellek.set(pid, urunler);
      }
      const secilen = urunler
        .filter((u) => !sepettekiler.includes(String(u.id)))
        .map((u) => ({ u, v: (u.variants || []).find((v) => v.available) }))
        .filter((x) => x.v)
        .slice(0, 3);
      if (!secilen.length) { this.sonHtml = ''; this.innerHTML = ''; return; }
      const kacis = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      this.sonHtml =
        `<p class="nso__baslik">${EN ? 'Frequently bought together' : 'Birlikte alın'}</p>` +
        secilen.map(({ u, v }) => {
          const img = (u.featured_image || '').replace(/(\.\w+)(\?|$)/, '_112x112$1$2');
          const tekVaryant = (u.variants || []).length === 1;
          return `<div class="nso__satir">
            <img src="${kacis(img)}" alt="" width="56" height="56" loading="lazy">
            <div><a class="nso__ad" href="${KOK}products/${kacis(u.handle)}">${kacis(u.title)}</a>
              <div class="nso__fiyat">${TL(v.price)}</div></div>
            ${tekVaryant
              ? `<button type="button" class="nso__ekle" data-v="${v.id}" data-img="${kacis(img)}">${EN ? 'Add' : 'Ekle'}</button>`
              : `<a class="nso__ekle" style="display:inline-flex;align-items:center;text-decoration:none" href="${KOK}products/${kacis(u.handle)}">${EN ? 'Select' : 'Seç'}</a>`}
          </div>`;
        }).join('');
      this.innerHTML = this.sonHtml;
    }
  }
  if (!customElements.get('nida-sepet-oneri')) customElements.define('nida-sepet-oneri', NidaSepetOneri);

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('button.nso__ekle');
    if (!b) return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    b.textContent = '…';
    try { await sepeteEkle(b.dataset.v, b.closest('.nso__satir').querySelector('img'), b.dataset.img); }
    catch (h) { b.textContent = 'Hata'; b.removeAttribute('aria-busy'); }
  });

  /* ---------- Sekmeli çok satanlar ---------- */
  class NidaSekmeler extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-panel]');
      this.tumu = this.querySelector('a.nsc__tumu');
      this.onbellek = new Map();
      this.querySelectorAll('[role="tab"]').forEach((t) => t.addEventListener('click', () => this.sec(t)));
      this.querySelectorAll('[data-kay]').forEach((b) => b.addEventListener('click', () => {
        const g = this.panel.querySelector('.nsc__izgara');
        g?.scrollBy({ left: Number(b.dataset.kay) * g.clientWidth * 0.8 });
      }));
      this.panel.addEventListener('scroll', () => this.oklar(), { capture: true, passive: true });
      this.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft'].includes(e.key) || !e.target.matches('[role="tab"]')) return;
        const s = [...this.querySelectorAll('[role="tab"]')];
        const i = (s.indexOf(e.target) + (e.key === 'ArrowRight' ? 1 : -1) + s.length) % s.length;
        s[i].focus(); this.sec(s[i]);
      });
      const ilk = this.querySelector('[aria-selected="true"]') || this.querySelector('[role="tab"]');
      // İlk sekmeyi bölüm görünür olmadan yükleme (sayfa hızını koru)
      const io = new IntersectionObserver((g) => { if (g.some((x) => x.isIntersecting)) { io.disconnect(); this.sec(ilk, true); } }, { rootMargin: '600px' });
      io.observe(this);
      // Yedek: gözlemci tetiklenmezse (gizli sekme, 0 genişlik) 2,5 sn sonra yine yükle
      setTimeout(() => { if (!this.panel.querySelector('.nsc-kart__ad')) { io.disconnect(); this.sec(ilk, true); } }, 2500);
      // Diğer sekmeleri boşta önden çek
      (window.requestIdleCallback || setTimeout)(() => this.querySelectorAll('[role="tab"]').forEach((t) => this.getir(t.dataset.url)), { timeout: 4000 });
    }
    oklar() {
      const g = this.panel.querySelector('.nsc__izgara');
      const [geri, ileri] = this.querySelectorAll('[data-kay]');
      if (!g || !geri) return;
      geri.disabled = g.scrollLeft < 8;
      ileri.disabled = g.scrollLeft + g.clientWidth >= g.scrollWidth - 8;
    }
    getir(url) {
      if (!this.onbellek.has(url)) {
        this.onbellek.set(url, fetch(url).then((r) => r.text()).then((h) => {
          const d = new DOMParser().parseFromString(h, 'text/html');
          return d.querySelector('.nsc__izgara')?.outerHTML || (EN ? '<p>No products found.</p>' : '<p>Ürün bulunamadı.</p>');
        }));
      }
      return this.onbellek.get(url);
    }
    async sec(t, ilk = false) {
      this.querySelectorAll('[role="tab"]').forEach((x) => { x.setAttribute('aria-selected', String(x === t)); x.tabIndex = x === t ? 0 : -1; });
      if (this.tumu) { this.tumu.href = t.dataset.tumu; this.tumu.textContent = `${EN ? 'All' : 'Tüm'} ${t.dataset.tumuAd || t.textContent.trim()} →`; }
      const html = await this.getir(t.dataset.url);
      if (t.getAttribute('aria-selected') !== 'true') return;
      const ciz = () => {
        this.panel.innerHTML = html;
        const kartlar = this.panel.querySelectorAll('.nsc-kart');
        // ilk panel açılışta (ekran dışında, 2,5 sn'de) yüklenir: canlandırma yok → açılışta ana iş parçacığı boş kalır.
        // Sekme değiştirince giriş animasyonu aynen var.
        // INP: kartlar hemen gelir; animasyon kurulumu ve ok ölçümü ekran boyandıktan sonra (2026-09-28)
        const sonra = (f) => requestAnimationFrame(() => setTimeout(f, 0));
        if (ilk) { /* statik */ }
        else if (window.gsap && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          kartlar.forEach((k) => { k.style.opacity = '0'; });
          sonra(() => gsap.fromTo(kartlar, { autoAlpha: 0, y: 22 }, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.05, ease: 'power3.out', clearProps: 'transform,opacity,visibility' }));
        } else this.panel.firstElementChild?.classList.add('is-gir');
        sonra(() => this.oklar());
      };
      if (!ilk && document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(ciz);
      else ciz();
    }
  }
  if (!customElements.get('nida-sekmeler')) customElements.define('nida-sekmeler', NidaSekmeler);
})();

/* Erişilebilirlik (2026-09-27, PSI/axe):
   - Tinker ürün şeritleri ekran dışındaki kartları aria-hidden="true" yapıyor ama içlerindeki bağlantı/düğmeler odaklanabilir
     kalıyor (aria-hidden-focus). Kartlar gerçekten tıklanabilir olduğu için yanlış gizlemeyi kaldırıyoruz.
   - Shobi sohbet balonuna erişilebilir ad. */
(() => {
  const SEC = '.resource-list__carousel slideshow-slide.resource-list__slide[aria-hidden="true"]';
  const temizle = (kok) => (kok || document).querySelectorAll(SEC).forEach((s) => s.removeAttribute('aria-hidden'));
  // Duyuru çubuğu: görünmeyen (aria-hidden) slaytlar inert → içindeki bağlantılar odak almaz (görünür slayt etkilenmez)
  const duyuru = () => document.querySelectorAll('.announcement-bar__slide').forEach((s) => { s.inert = s.getAttribute('aria-hidden') === 'true'; });
  const adla = () => { const b = document.getElementById('shobi-widget-bubble'); if (b && !b.hasAttribute('aria-label')) b.setAttribute('aria-label', /^en/i.test(document.documentElement.lang) ? 'Open chat assistant' : 'Sohbet asistanını aç'); return !!b; };
  let etiketli = false;
  const kur = () => {
    temizle(); duyuru();
    new MutationObserver((ml) => {
      for (const m of ml) {
        if (m.type === 'attributes' && m.target.matches && m.target.matches(SEC)) m.target.removeAttribute('aria-hidden');
        else if (m.type === 'attributes' && m.target.classList && m.target.classList.contains('announcement-bar__slide')) m.target.inert = m.target.getAttribute('aria-hidden') === 'true';
        else if (m.type === 'childList') {
          for (const n of m.addedNodes) if (n.nodeType === 1 && (n.matches(SEC) || n.querySelector('slideshow-slide'))) temizle(n.parentElement || n);
          if (!etiketli) etiketli = adla();
        }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
    etiketli = adla();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', kur, { once: true }) : kur();
})();
